import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DOUBLET_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { Contact } from '../../../classes';
import { DEPARTMENTS_PROVIDER_SERVICE } from '../../../interfaces';
import { ContactService } from '../../../services/contact.service';
import { CreateContactService } from '../../../services/create-contact-service';

@Component({
  selector: 'app-create-contact-dialog',
  templateUrl: './create-contact-dialog.component.html',
  styleUrls: ['./create-contact-dialog.component.css'],
  providers: [
    { provide: DOUBLET_PROVIDER_SERVICE, useClass: CreateContactService },
    { provide: DEPARTMENTS_PROVIDER_SERVICE, useExisting: DOUBLET_PROVIDER_SERVICE }
  ]
})
export class CreateContactDialogComponent  implements OnDestroy, OnInit {

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: CreateContactDialogComponentConfiguration,
    @Inject(DOUBLET_PROVIDER_SERVICE) public service: CreateContactService,
    private _ref: MatDialogRef<CreateContactDialogComponent>,
    private _formBuilder: FormBuilder,
    private _contactService: ContactService,
    private _snackBar: MatSnackBar,
    private _router: Router
  ) {
    this.formGroup = this._formBuilder.group(new Contact());
  }

  close = () => this._ref.close();

  ngOnDestroy(): void {
    this.service.dispose();
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.service.doubletClicked$.subscribe(() => this.close())
    ])
  }

  saveContact() {
    if (this.formGroup.invalid) return;
    this._contactService.createContact(this.formGroup.value, null).subscribe(
      (contact: Contact) => {
        if(!this._data || !this._data.preventNavigation) this._router.navigate(['/contact-details', contact.contactpersid]);
        this._ref.close(contact);
      },
      (error: HttpErrorResponse) => this._snackBar.open(`Fehler beim Erstellen des Ansprechpartners (${error.message})`, 'Abbrechen')
    );
  }

}

export class CreateContactDialogComponentConfiguration {
  preventNavigation: boolean;
}
